import { __decorate } from "tslib";
import { Vue, Component, Prop } from "../../../vue";
import styles from "./WConsoleModal.module.css";
import { logHandler } from '..';
import { LogRequestStatus } from "../../LogTable/common";
import DsLogList from "./DsLogList";
let WConsoleModal = class WConsoleModal extends Vue {
  constructor() {
    super(...arguments);
    this.logData = [];
    this.logFlow = {
      status: LogRequestStatus.NOT_LOADED_YET
    };
  }
  render() {
    const h = arguments[0];
    return h("a-modal", {
      "attrs": {
        "width": "1200px",
        "footer": this.pageId && this.projectId ? undefined : null,
        "visible": true,
        "destroyOnClose": true
      },
      "on": {
        "cancel": this.handleCancel
      }
    }, [this.pageId && this.projectId && h("a-button", {
      "slot": "footer",
      "attrs": {
        "type": "primary"
      },
      "on": {
        "click": this.goToEditingPage
      }
    }, ["\u6253\u5F00\u7F16\u8F91\u9875"]), h("div", {
      "slot": "title"
    }, [h("span", ["\u65E5\u5FD7\u5217\u8868"]), h("span", {
      "class": styles.modalTitlePs
    }, ["(\u53EA\u53EF\u67E5\u8BE2\u6700\u8FD1", logHandler.ttlms / 60000, "\u5206\u949F\u7684\u65E5\u5FD7\u4FE1\u606F)"])]), h(DsLogList, {
      "attrs": {
        "projectId": this.projectId
      }
    })]);
  }
  handleCancel() {
    this.$emit('cancel');
  }
  goToEditingPage() {
    window.open(`${document.location.origin}/xy/project/pageconfig?pageid=${this.pageId}&projectid=${this.projectId}`);
  }
};
__decorate([Prop({
  default: ''
})], WConsoleModal.prototype, "projectId", void 0);
__decorate([Prop({
  default: ''
})], WConsoleModal.prototype, "pageId", void 0);
WConsoleModal = __decorate([Component({
  name: 'WConsoleModal'
})], WConsoleModal);
export default WConsoleModal;
//# sourceMappingURL=WConsoleModal.js.map
